import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';

console.log('React version:', React.version);
console.log('ReactDOM.createRoot:', typeof ReactDOM.createRoot);
console.log('React.useRef:', typeof React.useRef);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

